import React, { useState, useEffect } from 'react';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
import CommonToggleButton from '../../../components/Dashboard-res/CommonComponent/CommonToggleButton';
import PopUp from '../../../common/components/PopUp/PopUp';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { ShowGetImage } from '../../../common/components/ShowGetImage/ShowGetImage';
import _ from 'lodash';
import initialImg from '../../../images/icons/upload_new.svg';
import get from 'lodash/get';
import { useFormikContext } from 'formik';
import styles from './PersonalDetails.module.css';
import {
  EmpPersonalDocUpload,
  EmpNRIPassUpload,
  UploadFileToS3,
  EmpPersonalDocUploaded,
  savePersonalDetails,
  getPersonalDetails
} from '../../../common/constants/api';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';

let maritalStatusOption = [
  {
    label: 'Single',
    value: 'Single'
  },
  {
    label: 'Married',
    value: 'Married'
  },
  {
    label: 'Widowed',
    value: 'Widowed'
  },
  {
    label: 'Divorced',
    value: 'Divorced'
  },
  {
    label: 'Other',
    value: 'Other'
  }
];

let religionOption = [
  {
    label: 'Hindu',
    value: 'Hindu'
  },
  {
    label: 'Muslim',
    value: 'Muslim'
  },
  {
    label: 'Christian',
    value: 'Christian'
  },
  {
    label: 'Sikh',
    value: 'Sikh'
  },
  {
    label: 'Buddhist',
    value: 'Buddhist'
  },
  {
    label: 'Jain',
    value: 'Jain'
  },
  {
    label: 'Other',
    value: 'Other'
  }
];
let categoryOption = [
  {
    label: 'General',
    value: 'General'
  },
  {
    label: 'OBC',
    value: 'OBC'
  },
  {
    label: 'SC',
    value: 'SC'
  }
];
let residentialOption = [
  {
    label: 'INDIAN',
    value: 'INDIAN'
  },
  {
    label: 'NRI',
    value: 'NRI'
  }
];

function PersonalDetails(props) {
  const [showFullImage, setShowFullImage] = useState(false);
  const [showResidential, setShowResidential] = useState(false);
  const [attorney, setAttorney] = useState(false);
  const [resNRI, setResNRI] = React.useState();
  const [salaryDocUploads, setSalaryDocUploads] = useState({});
  const [docUploaded, setDocUploaded] = useState(false);
  const [docUploadError, setDocUploadError] = useState(false);
  const [show, setShow] = useState(true);
  const [leadAppicant_Id, setLeadApplicant_Id] = useState(
    getApplicantionInfo().leadApplicantId
  );
  const [lead_Id, setLead_id] = useState(getApplicantionInfo().leadId);
  const [docId, setDocId] = useState('');
  const [loading, setLoading] = useState(false);
  const [LoadingFail, setLoadingFail] = useState(false);
  const [getDetailLoad, setGetDetailLoad] = useState(false);
  const [showError, setShowError] = useState('');
  const [hasDoc, setHasDoc] = useState(null);
  const [hasPOAttorney, setHasPOAttorney] = useState('');
  const [editPOAttorney, setEditPOAttorney] = useState(false);
  const [editPassportFront, setEditPassportFront] = useState(false);
  const [editPassportBack, setEditPassportBack] = useState(false);
  const [editVisa, setEditVisa] = useState(false);
  const [hasFrontPassport, setHasFrontPassport] = useState('');
  const [hasBackPassport, setHasBackPassport] = useState('');
  const [hasVisa, setHasVisa] = useState('');

  const { personal_details_box, container_align } = styles;
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    status,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();

  //geting leadId and ApplicantId
  useEffect(() => {
    let leadDetails = getApplicantionInfo();
    const { leadId, leadApplicantId } = leadDetails;
    setLead_id(leadId);
    setLeadApplicant_Id(leadApplicantId);
    return () => {};
  }, []);
  useEffect(() => {
    return () => {
      values.file = [];
      values.imgUrl = [];
    };
  }, []);

  //get api
  useEffect(() => {
    const getPersonal = async () => {
      if (lead_Id && leadAppicant_Id) setGetDetailLoad(true);
      getPersonalDetails(lead_Id, leadAppicant_Id)
        .then(async res => {
          if (res.error) {
            throw new Error(res);
          }
          if (res) {
            setHasDoc(true);
            setFieldValue('maritalStatus', {
              value: res?.maritalStatus || '',
              label: res?.maritalStatus || 'Marital Status'
            });
            setFieldValue('religion', {
              value: res?.religion || '',
              label: res?.religion || 'Religion'
            });
            setFieldValue('category', {
              value: res?.reservationCategory || '',
              label: res?.reservationCategory || 'Category'
            });

            setFieldValue('residential', {
              value: res?.residentialStatus || '',
              label: res?.residentialStatus || 'Residential Status'
            });
            if (res?.residentialStatus) {
              setResNRI(res?.residentialStatus);
            }
            if (res?.powerAttorney) {
              setAttorney(res?.powerAttorney);
            }
            if (res?.powerAttorneyDocLink?.url) {
              setHasPOAttorney(res.powerAttorneyDocLink.url);
            }
            if (res?.passportDocLinks) {
              setHasBackPassport(res.passportDocLinks[0].url);
              setHasFrontPassport(res.passportDocLinks[1].url);
            }
            if (res?.visaDocLink?.url) {
              setHasVisa(res.visaDocLink.url);
            }
          }
          setShow(false);
        })

        .catch(err => {
          setShow(false);
        });
    };

    getPersonal();
  }, [lead_Id, leadAppicant_Id]);

  //upload power-attorney

  useEffect(() => {
    setDocUploaded(false);
    setDocUploadError(false);
    setShow(true);
    if (values.file[0] && values.file[0] !== '') {
      setLoading(true);
      EmpPersonalDocUpload(
        values.file[0][0],
        lead_Id,
        leadAppicant_Id,
        'power-attorney',
        {
          'Content-Type': `${values.file[0][0].type}`
        }
      )
        .then(res => {
          let docId = res.requestId;
          UploadFileToS3(res.url, values.file[0][0], {
            'Content-Type': `${values.file[0][0].type}`
          })
            .then(res => {
              EmpPersonalDocUploaded(
                lead_Id,
                leadAppicant_Id,
                docId,
                'power-attorney'
              )
                .then(res => {
                  setDocUploaded(true),
                    setSalaryDocUploads({ ...salaryDocUploads, 0: 'uploaded' });
                })
                .catch(err => setDocUploadError(true));
            })
            .catch(err => setDocUploadError(true));
        })
        .catch(err => {
          setDocUploadError(true);
        });
    }
  }, [values.file[0]]);

  //upload passportFront

  useEffect(() => {
    setDocUploaded(false);
    setDocUploadError(false);
    setShow(true);
    if (values.file[1] && values.file[1] !== '') {
      setLoading(true);
      EmpNRIPassUpload(
        values.file[1][0],
        lead_Id,
        leadAppicant_Id,
        'passportFront',
        {
          'Content-Type': `${values.file[1][0].type}`
        }
      )
        .then(res => {
          let docId = res.requestId;
          UploadFileToS3(res.url, values.file[1][0], {
            'Content-Type': `${values.file[1][0].type}`
          })
            .then(res => {
              EmpPersonalDocUploaded(
                lead_Id,
                leadAppicant_Id,
                docId,
                'passport'
              )
                .then(res => {
                  setDocUploaded(true),
                    setSalaryDocUploads({ ...salaryDocUploads, 1: 'uploaded' });
                })
                .catch(err => setDocUploadError(true));
            })
            .catch(err => setDocUploadError(true));
        })
        .catch(err => {
          setDocUploadError(true);
        });
    }
  }, [values.file[1]]);

  //upload passportBack
  useEffect(() => {
    setDocUploaded(false);
    setDocUploadError(false);
    setShow(true);
    if (values.file[2] && values.file[2] !== '') {
      setLoading(true);
      EmpNRIPassUpload(
        values.file[2][0],
        lead_Id,
        leadAppicant_Id,
        'passportBack',
        {
          'Content-Type': `${values.file[2][0].type}`
        }
      )
        .then(res => {
          let docId = res.requestId;
          UploadFileToS3(res.url, values.file[2][0], {
            'Content-Type': `${values.file[2][0].type}`
          })
            .then(res => {
              EmpPersonalDocUploaded(
                lead_Id,
                leadAppicant_Id,
                docId,
                'passport'
              )
                .then(res => {
                  setDocUploaded(true),
                    setSalaryDocUploads({ ...salaryDocUploads, 2: 'uploaded' });
                })
                .catch(err => setDocUploadError(true));
            })
            .catch(err => setDocUploadError(true));
        })
        .catch(err => {
          setDocUploadError(true);
        });
    }
  }, [values.file[2]]);

  //uploading visa

  useEffect(() => {
    setDocUploaded(false);
    setDocUploadError(false);
    setShow(true);
    if (values.file[3] && values.file[3] !== '') {
      setLoading(true);
      EmpPersonalDocUpload(
        values.file[3][0],
        lead_Id,
        leadAppicant_Id,
        'visa',
        {
          'Content-Type': `${values.file[3][0].type}`
        }
      )
        .then(res => {
          let docId = res.requestId;
          UploadFileToS3(res.url, values.file[3][0], {
            'Content-Type': `${values.file[3][0].type}`
          })
            .then(res => {
              EmpPersonalDocUploaded(lead_Id, leadAppicant_Id, docId, 'visa')
                .then(res => {
                  setDocUploaded(true),
                    setSalaryDocUploads({ ...salaryDocUploads, 3: 'uploaded' });
                })
                .catch(err => setDocUploadError(true));
            })
            .catch(err => setDocUploadError(true));
        })
        .catch(err => {
          setDocUploadError(true);
        });
    }
  }, [values.file[3]]);

  useEffect(() => {
    validateForm();
    if (
      values.file[0] &&
      values.file[1] &&
      values.file[2] &&
      values.file[3] &&
      values.file[0] !== '' &&
      values.file[1] !== '' &&
      values.file[2] !== '' &&
      values.file[3] !== ''
    ) {
      setShowFullImage(true);
    }
  }, [values.file]);
  //save api
  const onSubmitHandler = async () => {
    const leadData = await getApplicantionInfo();
    await savePersonalDetails(leadData.leadId, leadData.leadApplicantId, {
      maritalStatus: values.maritalStatus.value,
      religion: values.religion.value,
      reservationCategory: values.category.value,
      residentialStatus: values.residential.value,
      powerAttorney: attorney
    })
      .then(res => {
        if (res.error) {
          throw new Error(res);
        } else {
          handleSubmit();
        }
      })
      .catch(err => {
        setShow(false);
      });
  };

  const applyCondtn = () => {
    if (
      docUploaded ||
      docUploadError ||
      loading ||
      getDetailLoad ||
      LoadingFail
    )
      return true;
  };

  const propsRenderer = () => {
    let props = {};

    if (LoadingFail?.status === 403) {
      props.goto = LoadingFail?.status == 403;
      props.dontClose = LoadingFail?.status == 403;
      props.type = 'fail';
      props.text = LoadingFail?.message;
      return props;
    }
    if (docUploaded) {
      props.type = 'success';
      props.text = 'Document uploaded successfully';
      props.autoClose = true;
      return props;
    }

    if (docUploadError) {
      props.type = 'fail';
      props.text = 'Error uploading the file, please try again ';
      props.autoClose = true;
      return props;
    }

    if (loading) {
      props.type = 'loading';
      props.text = 'Uploading document. . . ';
      return props;
    }

    if (getDetailLoad) {
      props.type = 'loading';
      props.text = 'Getting Personal Details..';

      return props;
    }
  };

  return (
    <React.Fragment>
      {applyCondtn() && (
        <PopUp {...propsRenderer()} setShow={setShow} show={show} />
      )}
      <div className={`${personal_details_box}`}>
        {!showResidential ? (
          <React.Fragment>
            <h1 className="text-center text-2xl py-4 font-khand text-xl font-semibold">
              Personal Details
            </h1>
            <div
              className={`${container_align} m-2 md:mx-auto p-6 py-10 md:p-8 
         bg-white  rounded-lg font-normal font-roboto text-sm text-black-500`}
            >
              <CommonSelect sort={true}
                name="maritalStatus"
                value={values.maritalStatus}
                onChange={anyvalue => {
                  setFieldValue('maritalStatus', anyvalue, true);
                  setFieldTouched('maritalStatus', true, false);
                }}
                onBlur={() => {
                  setFieldTouched('maritalStatus', true, true);
                }}
                options={[
                  {
                    label: 'Marital Status',
                    value: ''
                  },
                  ...maritalStatusOption
                ]}
                stylesContainer={{
                  height: '52px',
                  marginBottom: '40px',
                  fontSize: '40px'
                }}
                dropdownStyle={{
                  top: '55px'
                }}
                styleText={{
                  fontSize: '14px',
                  padding: '0 25px'
                }}
                error={
                  touched.maritalStatus &&
                  get(errors, 'maritalStatus.value', false)
                }
                errorMsg={get(errors, 'maritalStatus.value', false)}
                touched={touched.maritalStatus}
              />
              <CommonSelect sort={true}
                name="religion"
                value={values.religion}
                onChange={anyvalue => {
                  setFieldValue('religion', anyvalue, true);
                  setFieldTouched('religion', true, false);
                }}
                onBlur={() => {
                  setFieldTouched('religion', true, true);
                }}
                options={[
                  {
                    label: 'Religion',
                    value: ''
                  },
                  ...religionOption
                ]}
                stylesContainer={{
                  height: '52px',
                  marginBottom: '40px',
                  fontSize: '40px'
                }}
                dropdownStyle={{
                  top: '55px'
                }}
                styleText={{
                  fontSize: '14px',
                  padding: '0 25px'
                }}
                error={touched.religion && get(errors, 'religion.value', false)}
                errorMsg={get(errors, 'religion.value', false)}
                touched={touched.religion}
              />
              <CommonSelect sort={true}
                name="category"
                value={values.category}
                onChange={anyvalue => {
                  setFieldValue('category', anyvalue, true);
                  setFieldTouched('category', true, false);
                }}
                onBlur={() => {
                  setFieldTouched('category', true, true);
                }}
                options={[
                  {
                    label: 'Category',
                    value: ''
                  },
                  ...categoryOption
                ]}
                stylesContainer={{
                  height: '52px',
                  marginBottom: '40px',
                  fontSize: '40px'
                }}
                dropdownStyle={{
                  top: '55px'
                }}
                styleText={{
                  fontSize: '14px',
                  padding: '0 25px'
                }}
                error={touched.category && get(errors, 'category.value', false)}
                errorMsg={get(errors, 'category.value', false)}
                touched={touched.category}
              />

              <CommonSelect sort={true}
                name="residential"
                value={values.residential}
                onChange={e => {
                  setFieldValue('residential', e, true);
                  setFieldTouched('residential', true, false);
                  setResNRI(e.value);
                }}
                onBlur={() => {
                  setFieldTouched('residential', true, true);
                }}
                options={[
                  {
                    label: 'Residential Status',
                    value: ''
                  },
                  ...residentialOption
                ]}
                stylesContainer={{
                  height: '52px',
                  marginBottom: '40px',
                  fontSize: '40px'
                }}
                dropdownStyle={{
                  top: '55px'
                }}
                styleText={{
                  fontSize: '14px',
                  padding: '0 25px'
                }}
                error={
                  touched.residential && get(errors, 'residential.value', false)
                }
                errorMsg={get(errors, 'residential.value', false)}
                touched={touched.residential}
              />
              <div
                className={resNRI == 'INDIAN' ? 'hidden ' : ' block md:hidden'}
              >
                <button
                  disabled={
                    errors.maritalStatus || errors.religion || errors.category
                  }
                  className="submitButton w-56"
                  onClick={() => setShowResidential(true)}
                >
                  Next
                </button>
              </div>
            </div>
          </React.Fragment>
        ) : null}
        <div
          className={
            showResidential && resNRI == 'NRI' ? 'pt-4' : 'hidden md:block'
          }
        >
          {resNRI == 'NRI' ? (
            <>
              <CommonToggleButton
                name="powerAttorney"
                labelName="Power of Attorney"
                Id="powerAttorney"
                labelFor="powerAttorney"
                checked={attorney}
                stylesContainer={{
                  alignItems: 'left',
                  marginLeft: '1.3rem'
                }}
                onChange={e => {
                  setAttorney(e.target.checked);
                }}
              />

              {attorney === true ? (
                <React.Fragment>
                  <div className="bg-white border border-navy-200  md:border-0 w-full px-2 md:px-0 rounded-lg py-4 md:py-0">
                    <div className=" w-full flex  flex-wrap lg:pr-4 lg:px-5 md:mx-auto ">
                      {hasPOAttorney && !editPOAttorney ? (
                        <div className="ml-2 mt-2">
                          <p className="mb-3 text-grey-50 ">
                            Power of Attorney{' '}
                          </p>
                          <ShowGetImage
                            img={hasPOAttorney}
                            setEdit={setEditPOAttorney}
                          />
                        </div>
                      ) : (
                        <div className=" block md:mr-auto attorney">
                          <p className="block font-roboto font-bold text-black-850 lg:pr-4 lg:px-5 mr-auto py-3 text-sm">
                            Upload Power of Attorney
                          </p>
                          <GlobalUploadComp
                            data={values}
                            imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            setFieldValue={setFieldValue}
                            setFieldTouched={setFieldTouched}
                            setFieldError={setFieldError}
                            initialImg={initialImg} // initial image
                            showFullImage={showFullImage}
                            subInst="Click here to Upload Power of Attorney"
                            subtext="Upload"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ) : null}
              <div className="bg-white border border-navy-200  md:border-0 w-full px-2 md:px-0 rounded-lg py-4 md:py-0 mt-4">
                <p className="block font-roboto font-bold text-black-850 lg:pr-4 lg:px-5 mr-auto py-3 text-sm">
                  Upload Passport
                </p>
                <div className=" w-full flex  flex-wrap lg:pr-4 lg:px-5 md:mx-auto ">
                  {hasFrontPassport && !editPassportFront ? (
                    <div className="ml-2 mt-2 md:mr-20">
                      <ShowGetImage
                        img={hasFrontPassport}
                        setEdit={setEditPassportFront}
                      />
                    </div>
                  ) : (
                    <div className=" block md:mr-auto">
                      <GlobalUploadComp
                        data={values}
                        imgIndex={1} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        initialImg={initialImg} // initial image
                        showFullImage={showFullImage}
                        subInst="Click here to Upload Front Page of passport"
                        subtext="Upload Front"
                      />
                    </div>
                  )}
                  {hasBackPassport && !editPassportBack ? (
                    <div className="ml-2 mt-2">
                      <ShowGetImage
                        img={hasBackPassport}
                        setEdit={setEditPassportBack}
                      />
                    </div>
                  ) : (
                    <div className=" block">
                      <GlobalUploadComp
                        data={values}
                        imgIndex={2} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        initialImg={initialImg} // initial image
                        showFullImage={showFullImage}
                        subInst="Click here to Upload Back Page of Passport"
                        subtext="Upload back"
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="bg-white border border-navy-200  md:border-0 w-full px-2 md:px-0 rounded-lg py-4 md:py-0 mt-4">
                <div className=" w-full flex  flex-wrap lg:pr-4 lg:px-5 md:mx-auto ">
                  {hasVisa && !editVisa ? (
                    <div className="ml-2 mt-2">
                      <p className="mb-3 text-grey-50 ">Visa </p>
                      <ShowGetImage img={hasVisa} setEdit={setEditVisa} />
                    </div>
                  ) : (
                    <div className=" block md:mr-auto">
                      <p className="block font-roboto font-bold text-black-850 lg:pr-4 lg:px-5 mr-auto py-3 text-sm">
                        Upload Visa
                      </p>
                      <GlobalUploadComp
                        data={values}
                        imgIndex={3} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        showFullImage={showFullImage}
                        initialImg={initialImg} // initial image
                        subInst="Click here to Upload Visa "
                        subtext="Upload Visa"
                      />
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            ''
          )}
        </div>
        <div
          className={
            ((showResidential && resNRI == 'NRI') || resNRI == 'INDIAN'
              ? 'block'
              : 'hidden md:block') + ' mt-20'
          }
        >
          <button
            onClick={onSubmitHandler}
            disabled={!_.isEmpty(errors)}
            className="submitButton w-56 lg:w-80 font-semibold"
            type="button"
            id="submitdet"
          >
            NEXT
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
export default withErrorHandler(PersonalDetails);
